import React      from 'react'
import PropTypes  from 'prop-types'

import NameDescriptionEntity from './NameDescriptionEntity'

export default class ReRoutingStepConfigRenderer extends React.Component {
  static propTypes = {
    step: PropTypes.object.isRequired,
  }

  render() {
    const { step } = this.props

    return (
      <div>
        {step.config.sender && (
          <NameDescriptionEntity
            title="Sender"
            item={step.config.sender}
            url={`/data-systems/item/${step.config.sender.id}`}
          />
        )}
        {step.config.receiver && (
          <NameDescriptionEntity
            title="Receiver"
            item={step.config.receiver}
            url={`/data-systems/item/${step.config.receiver.id}`}
          />
        )}
        {step.config.dataType && (
          <NameDescriptionEntity
            title="Data Type"
            item={step.config.dataType}
            url={`/data-types/item/${step.config.dataType.id}`}
          />
        )}
      </div>
    )
  }
}
